import React, { FC, ReactNode } from 'react'

type EatableFormSectionHeadingProps = {
  children: ReactNode
}

export const EatableFormSectionHeading: FC<EatableFormSectionHeadingProps> = ({ children }) => (
  <h4 className="eatable-form-section-heading mt-1">{children}</h4>
)
